import { Card } from '@sravni/react-design-system';
import type { CardColor, CardSize } from '@sravni/react-design-system/dist/types/components/Card/types/Card.types';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import React from 'react';

import styles from './AdaptiveCard.module.scss';

interface IAdaptiveCardProps {
  color?: CardColor;
  desktopSize?: CardSize;
  mobileSize?: CardSize;
  isHideCardWrapper?: boolean;
  isWithoutPadding?: boolean;
  isVertical?: boolean;
}
export const AdaptiveCard: FC<IAdaptiveCardProps> = ({
  desktopSize = 32,
  mobileSize = 16,
  isHideCardWrapper,
  isWithoutPadding,
  children,
  className,
  color = 'dark',
  isVertical,
}) => {
  const isMobile = useIsMobile();

  if (isHideCardWrapper) {
    return <div>{children}</div>;
  }

  return (
    <Card
      size={isMobile ? mobileSize : desktopSize}
      color={color}
      className={cn(
        { [styles.adaptiveCardWithoutPadding]: isWithoutPadding, [styles.adaptiveCardVertical]: isVertical },
        className,
      )}
    >
      {children}
    </Card>
  );
};
